// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x_Yd","icon":"styles_icon__1SsoW"};